import React from 'react';
import PropTypes from 'prop-types';

const MessageBox = ({ messageType, messageHeader, messageBody, extraClass, onClose }) => {  
  const [isClosed, setIsClosed] = React.useState(false);  
  

  const handleOnClose = () => {
    setIsClosed(true);        
    if (onClose){
      onClose();
    }
  }

  if (isClosed)
  {
    return null;
  }

  return (
    <div className={`message ${messageType} ${extraClass}`}>
      <div className="message__header">
        <h1>{messageHeader}</h1>
        {onClose && <div className="message-close icon-close" onClick={handleOnClose} />}
      </div>
      {messageBody && messageBody !== '' && (
        <div className="message__content">
          {typeof messageBody === 'string' ? <p>{messageBody}</p> : messageBody}
        </div>
      )}
    </div>
  );
};

MessageBox.propTypes = {
  messageType: PropTypes.string,
  messageHeader: PropTypes.string,
  messageBody: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  extraClass: PropTypes.string,
  onClose: PropTypes.func
};

MessageBox.defaultProps = {
  messageType: '',
  messageHeader: '',
  messageBody: '',
  extraClass: ''
};

export default MessageBox;
